import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import * as bootstrap from "bootstrap";
import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
import VCalendar from "v-calendar";
import * as Sentry from "@sentry/vue";

import "vue-loading-overlay/dist/vue-loading.css";
import "./plugins/mixins.js";
import "typeface-roboto";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Sentry.init({
  Vue,
  dsn: "https://d478346bcafca0f57cb3d7e07c900e45@o4507073401782272.ingest.us.sentry.io/4507073403224064",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/qa-gerenciarmidias.cliqx.com.br\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

Vue.use(bootstrap);
Vue.use(StepProgress);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueAxios, axios);
Vue.use(VCalendar);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
